import React, { useCallback, useContext } from "react";
import { CtaCustomData } from "../CtasContainer/CtasContainer";
import { PluginDataContext } from "../../../../pluginsInfrastructure/PluginDataContextProvider";
import { PageStaticDataContext } from "../../../../contexts/PageStaticDataContextProvider";
import { BffDataContext } from "../../../../contexts/BffDataContextProvider";
import { ProductContext } from "../../../../contexts/ProductContextProvider";
import { getProductCtaInfo } from "../../utils/ctaHelpers";
import { analyticsPageData } from "../../../../utils/analyticsConfig";
import { CtaButton } from "./CtaButton";
import {
  AddToCartOptions,
  addToCartOnClickHandler,
  getAddToCartImageUrl,
} from "../../utils/addToCart";
import { MpvProvider } from "../../../../utils/MpvProvider";
import { ReferentialImageContext } from "../../../../contexts/ReferentialImagesContext";
import { useScreenClass } from "@vp/swan";
import { getScreenClass } from "../../../../utils/screenClass";
export interface AddToCartCtaProps {
  customData: CtaCustomData;
}

const AddToCartCta = (props: AddToCartCtaProps) => {
  const {
    customData: {
      flow: { type },
      isPrimaryCta,
      buttonIndex,
      showDescription,
      isDesignUploaded,
      isLastCta,
    },
  } = props;
  const { pluginData } = useContext(PluginDataContext);
  const {
    locale,
    country,
    tenant,
    mpv,
    ctaOverrideEntries,
    vistacartTenant,
    heroGallery,
    productBuilderOptions,
  } = useContext(PageStaticDataContext);
  const { temporarilyOutOfStock, prices, initialPrices } = useContext(BffDataContext);
  const {
    selections,
    clientSideStateInitialized,
    initialSelections,
    initialQuantity,
    selectedQuantity,
  } = useContext(ProductContext);
  const { selectedReferentialImage } = useContext(ReferentialImageContext);
  const { isMobile } = getScreenClass(useScreenClass());

  const { mpvId, coreProductId, version, name } = mpv;
  const ctaEnabled = clientSideStateInitialized && !temporarilyOutOfStock;

  const mpvProvider = new MpvProvider(mpv);
  const productPageMerchandisingDetail = mpvProvider.getProductPageMerchandisingDetails();

  const { actualCtaText, actualCtaDescription, actualCtaIcon } = getProductCtaInfo(
    pluginData,
    ctaOverrideEntries,
    type,
    isDesignUploaded,
    isPrimaryCta
  );

  const addToCartImageUrl = getAddToCartImageUrl({
    heroGallery,
    defaultMpvImageUrl: mpvProvider.getDefaultProductImageUrl(),
    selectedReferentialImage,
  });

  const onClickHandler = useCallback(
    (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
      const addToCartOptions: AddToCartOptions = {
        productKey: coreProductId,
        locale,
        country,
        tenant,
        quantity: selectedQuantity,
        productName: name,
        selections: selections || {},
        imageUrl: addToCartImageUrl,
        productPageMerchandisingDetail,
        vistacartTenant: vistacartTenant?.tenantId,
        initialSelections,
        mpvId,
        pageSection: analyticsPageData.pageSection,
        prices,
        version,
        isMobile,
        productBuilderOptions,
        initialPrices,
      };
      return addToCartOnClickHandler(event, addToCartOptions, initialQuantity);
    },
    [
      mpvId,
      coreProductId,
      locale,
      selectedQuantity,
      name,
      addToCartImageUrl,
      vistacartTenant,
      productPageMerchandisingDetail,
      selections,
      initialSelections,
      analyticsPageData,
      buttonIndex,
      type,
      initialSelections,
      prices,
      version,
      isMobile,
    ]
  );

  return (
    <CtaButton
      onClickHandler={onClickHandler}
      disabled={!ctaEnabled}
      buttonKey={type}
      text={actualCtaText}
      description={showDescription ? actualCtaDescription : ""}
      iconComponent={actualCtaIcon}
      textButtonProps={{
        skin: isPrimaryCta ? "primary" : "secondary",
      }}
      addBottomSpace={!isLastCta}
      pageSection={analyticsPageData.pageSection}
      position={buttonIndex}
    />
  );
};

export default AddToCartCta;
